import {
    RESET_ORDER_ACTION_STATE,
    RESET_ORDER_STATE,
    GET_ORDER_LISTING,
    GET_ORDER_LISTING_SUCCESS,
    GET_ORDER_LISTING_FAIL,
    GET_ORDER_DETAILS,
    GET_ORDER_DETAILS_SUCCESS,
    GET_ORDER_DETAILS_FAIL,
    UPDATE_ORDER_STATUS,
    UPDATE_ORDER_STATUS_SUCCESS,
    UPDATE_ORDER_STATUS_FAIL,
    EXPORT_ORDER,
    EXPORT_ORDER_SUCCESS,
    EXPORT_ORDER_FAIL,
    EXPORT_ORDER_DETAILS,
    EXPORT_ORDER_DETAILS_SUCCESS,
    EXPORT_ORDER_DETAILS_FAIL,
} from "./actionTypes";

export const getOrderListing = (data) => ({
    type: GET_ORDER_LISTING,
    payload: data,
});

export const getOrderListingSuccess = data => ({
    type: GET_ORDER_LISTING_SUCCESS,
    payload: data,
});

export const getOrderListingFail = error => ({
    type: GET_ORDER_LISTING_FAIL,
    payload: error,
});

export const getOrderDetails = (data) => ({
    type: GET_ORDER_DETAILS,
    payload: data,
});

export const getOrderDetailsSuccess = data => ({
    type: GET_ORDER_DETAILS_SUCCESS,
    payload: data,
});

export const getOrderDetailsFail = error => ({
    type: GET_ORDER_DETAILS_FAIL,
    payload: error,
});

export const updateOrderStatus = (data) => ({
    type: UPDATE_ORDER_STATUS,
    payload: data,
});

export const updateOrderStatusSuccess = data => ({
    type: UPDATE_ORDER_STATUS_SUCCESS,
    payload: data,
});

export const updateOrderStatusFail = error => ({
    type: UPDATE_ORDER_STATUS_FAIL,
    payload: error,
});

export const exportOrder = (data) => ({
    type: EXPORT_ORDER,
    payload: data,
});

export const exportOrderSuccess = data => ({
    type: EXPORT_ORDER_SUCCESS,
    payload: data,
});

export const exportOrderFail = error => ({
    type: EXPORT_ORDER_FAIL,
    payload: error,
});

export const exportOrderDetails = (data) => ({
    type: EXPORT_ORDER_DETAILS,
    payload: data,
});

export const exportOrderDetailsSuccess = data => ({
    type: EXPORT_ORDER_DETAILS_SUCCESS,
    payload: data,
});

export const exportOrderDetailsFail = error => ({
    type: EXPORT_ORDER_DETAILS_FAIL,
    payload: error,
});

//reset
export const resetOrderActionState = () => {
    return {
        type: RESET_ORDER_ACTION_STATE,
    }
}
export const resetOrderState = () => {
    return {
        type: RESET_ORDER_STATE,
    }
}

